import react from "react";
import Footer from "../component/Footer";
import Header from "../component/Header";
import { Link } from "react-router-dom";
import ScrollToTop from "../component/ScrollToTop";
export default function Home() {
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="hero_img position-relative hero_padding">
          <div className="container">
            <div className="row my-5">
              <div className="col-lg-7">
                <h1 className="heading-1 mb-xl-4 mb-3">
                  Engineering solutions <br className="d-md-block d-none" /> for
                  tomorrow's world
                </h1>
                <p className="sub_para body-regular mb-4">
                  We help you unlock the power of teams and technology, so you
                  can confidently plan, design & build tomorrow. For your
                  customers, for your people, for your entire organization.
                </p>
                <Link
                  to="/contact"
                  className="btn blockcryp_button font_14 fw-bold"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding bg-black">
          <div className="container">
            <h2 className="heading-2 mb-2 text-white">
              Build better with Engineering first principles.
            </h2>
            <p className="sub_para body-regular mb-5">
              We create software that engages your users at scale, transforming
              your business.
            </p>
            <div className="row text-white g-md-5 g-3">
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">Blockchain & DeFi</h6>
                <p className="sub_para para_color">
                  Design, develop and launch products using blockchain
                  technology.
                </p>
              </div>
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">Technology Consulting</h6>
                <p className="sub_para para_color">
                  Leverage our global footprint and add technical velocity to
                  your advantage.
                </p>
              </div>
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">Software Engineering</h6>
                <p className="sub_para para_color">
                  Development of new applications including management,
                  maintenance and deployment.
                </p>
              </div>
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">Mobile Apps</h6>
                <p className="sub_para para_color">
                  Build iOS, Android and Cross Platform applications with App
                  store listing compliance.
                </p>
              </div>
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">Cyber Security</h6>
                <p className="sub_para para_color">
                  Enhance cybersecurity posture, increase compliance and build
                  digital resilience.
                </p>
              </div>
              <div className="col-lg-4 col-md-6">
                <h6 className="sub_heading">UI/UX Design</h6>
                <p className="sub_para para_color">
                  Create Design Systems, Interface Designs and User Experiences
                  for your clients.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="overflow-hidden bg-blue">
          <div className="row align-items-center g-xl-5 g-0">
            <div className="col-xl-6 px-0">
              <div className="h-100">
                <img
                  src="assets/639b830a4cbdd25590f3a9e7_metrix-bg.png"
                  alt=""
                  className="w-100 eye_img"
                />
              </div>
            </div>
            <div className="col-xl-6 ">
              <div className="left_padding">
                <div className="row">
                  <div className="col-xl-8">
                    <h2 className="heading-2 mb-xl-4 mb-3">
                      For Engineers, by Engineers.
                    </h2>
                    <p className="sub_para">
                      With international recognition of our work, our software
                      engineering expertise is deep rooted in our DNA - creating
                      functional products and writing compelling code.
                    </p>
                    <div className="row mt-4 g-3">
                      <div className="col-6">
                        <p className="font_14 mb-md-2 mb-1">
                          Direct consumer impact
                        </p>
                        <p className="sub_heading">15 million</p>
                      </div>
                      <div className="col-6">
                        <p className="font_14 mb-md-2 mb-1">
                          Projects launched
                        </p>
                        <p className="sub_heading">50+</p>
                      </div>
                      <div className="col-6">
                        <p className="font_14 mb-md-2 mb-1">
                          Engineering Experience
                        </p>
                        <p className="sub_heading">35 Years</p>
                      </div>
                      <div className="col-6">
                        <p className="font_14 mb-md-2 mb-1">Talent</p>
                        <p className="sub_heading">15 Specialists</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="row g-xl-0 g-4">
              <h2 className="heading-2 mb-xl-5 mb-lg-4 mb-2 text-center text-sm-start">
                Building better. Together.
              </h2>
              <div className="col-lg-2 col-md-4 col-6 ">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399bf04383df7ba914fb3_algorand-logo%403x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-6">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399c0c8c1bd23a3dfb01e_google-logo%403x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-6 ">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399bfefca1136c6c37597_aws-logo%403x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-6">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399bf2393cc0df3939a40_certik-logo%403x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-6">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399c0a9186364e8d218dc_immuniweb-logo%403x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div className="col-lg-2 col-md-4 col-6">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a399c1c031257c45a039b4_meta-logo%402x.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
              <p className="sub_para mt-lg-5 mt-3 text-center text-sm-start">
                We team up with world's leading solution providers who are
                obsessed with building highest-quality products and experiences.
              </p>
            </div>
          </div>
        </section>
        <section className="section_padding qoute-block">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <h2 className="sub_title text-white mb-xl-4 mb-3">
                  Engineering forward.
                </h2>
                <p className="sub_para body-regular">
                  We are an engineering first organisation dedicated to
                  architecting sophisticated, scalable solutions with decades of
                  R&D and Open Source experience.
                </p>
                <Link
                  to="/contact"
                  className="btn blockcryp_button font_14 fw-bold mt-xl-3 mt-2"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </section>
     
        <section className="section_padding bg_dark">
          <div className="container">
            <div className="row align-items-center text-white gy-xl-5 gy-4">
              <div className="col-md-9">
                <h2 className="heading-2">Recent liftoffs</h2>
                <p className="sub_para body-regular mb-0">
                  Browse through our most recent product launches and
                  engineering projects. Our capabilities cover a wide range of
                  production-grade deployments such as Mobile, Web, Serverless
                  and Blockchain applications.
                </p>
              </div>
              <div className="col-md-3 d-md-flex d-none justify-content-end">
                <button type="button" className="btn text-white grey_button ">
                  View all
                </button>
              </div>
              <div className="col-lg-6">
                <div className="left_bg left_right_sec">
                  <div className="">
                    <h3 className="heading-4 white-color">
                      Augusta Platforms Inc
                    </h3>
                    <p className="sub_para mb-md-3 mb-2">
                      Wellness focused social media experience
                    </p>
                    <ul className="list-unstyled boxes">
                      <li className="tag-box">iOS</li>
                      <li className="tag-box">Android</li>
                      <li className="tag-box">Mobile</li>
                      <li className="tag-box">Social Media</li>
                      <li className="tag-box">+3</li>
                    </ul>
                  </div>
                  <img
                    src="assets/img/639b830a4cbdd20fd5f3a9a9/63f7ae17f6fe9766bf954ce8_image%2019%402x.png"
                    alt=""
                    className="mobile-img"
                  />
                </div>
              </div>

              <div className="col-lg-6 ">
                <div className="right_bg left_right_sec">
                  <div className="">
                    <h3 className="heading-4 white-color">Outstaffer</h3>
                    <p className="sub_para mb-md-3 mb-2">
                      Hire and build the best team on the planet
                    </p>
                    <ul className="d-flex list-unstyled boxes">
                      <li className="tag-box">Software</li>
                      <li className="tag-box">EOR</li>
                      <li className="tag-box">Web</li>
                      <li className="tag-box">Design</li>
                      <li className="tag-box">+3</li>
                    </ul>
                  </div>
                  <img
                    src="assets/img/639b830a4cbdd20fd5f3a9a9/639b830a4cbdd24eebf3aa81_outstaffer-thumb.png"
                    alt=""
                    className="mobile-img outstaffer-pro-img"
                  />
                </div>
              </div>
              <div className="col-3 d-md-none d-flex justify-content-center w-100 mt-md-0 mt-4">
                <button
                  type="button"
                  className="btn text-white grey_button w-100 py-2"
                >
                  View all
                </button>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </ScrollToTop>
    </>
  );
}




<section className="section_padding pt-0">
<div className="container">
  <div className="row justify-content-center">
    <div className="col-xl-8">
      <h2 className="heading-2 text-center">
        Ingredients for your build
      </h2>
      <p className="sub_para text-center mb-xl-5 mb-3">
        Having projects delivered around the world, our clients have
        taught us that truly <br /> great engineering consists
        multiple, interconnected elements.
      </p>
      <div className=" row overflow-auto my-xl-5 my-4">
        <div className="d-flex justify-content-center">
          <ul
            className="nav nav-pills d-flex flex-nowrap overflow-auto  gap-md-4 gap-2"
            id="pills-tab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active font_14 fw-semibold text-nowrap tech_pill"
                id="frontend-tab"
                data-bs-toggle="tab"
                data-bs-target="#frontend"
                type="button"
                role="tab"
                aria-controls="frontend"
                aria-selected="true"
              >
                Frontend
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link font_14 fw-semibold text-nowrap tech_pill"
                id="backend-tab"
                data-bs-toggle="tab"
                data-bs-target="#backend"
                type="button"
                role="tab"
                aria-controls="backend"
                aria-selected="false"
              >
                Backend
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link font_14 fw-semibold text-nowrap tech_pill"
                id="blockchain-tab"
                data-bs-toggle="tab"
                data-bs-target="#blockchain"
                type="button"
                role="tab"
                aria-controls="blockchain"
                aria-selected="false"
              >
                Blockchain
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link font_14 fw-semibold text-nowrap tech_pill"
                id="mobile-tab"
                data-bs-toggle="tab"
                data-bs-target="#mobile"
                type="button"
                role="tab"
                aria-controls="mobile"
                aria-selected="false"
              >
                Mobile
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link font_14 fw-semibold text-nowrap tech_pill"
                id="devops-tab"
                data-bs-toggle="tab"
                data-bs-target="#devops"
                type="button"
                role="tab"
                aria-controls="devops"
                aria-selected="false"
              >
                Infra & DevOps
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link font_14 fw-semibold text-nowrap tech_pill"
                id="uiux-tab"
                data-bs-toggle="tab"
                data-bs-target="#uiux"
                type="button"
                role="tab"
                aria-controls="uiux"
                aria-selected="false"
              >
                UI/UX
              </button>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div className="container">
  <div className="tech_border p-2">
    <div className="row justify-content-center text-center py-md-4 pb-0">
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/reactjs.svg"
          alt="ReactJS"
          className="img-fluid"
        />
        <p className="font_14 mb-0">ReactJS</p>
      </div>
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/angulerjs.svg"
          alt="Angular"
          className="img-fluid"
        />
        <p className="font_14 mb-0">Angular</p>
      </div>
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/typescript.svg"
          alt="TypeScript"
          className="img-fluid"
        />
        <p className="font_14 mb-0">TypeScript</p>
      </div>
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/jquery.svg"
          alt="jQuery"
          className="img-fluid "
        />
        <p className="font_14 mb-0">jQuery</p>
      </div>
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/vuejs.svg"
          alt="VueJS"
          className="img-fluid"
        />
        <p className="font_14 mb-0">VueJS</p>
      </div>
    </div>
    <div className="row justify-content-center text-center pb-md-4 ">
      <div className="col-md-2  my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/nextjs.svg"
          alt="NextJS"
          className="img-fluid"
        />
        <p className="font_14 mb-0">NextJS</p>
      </div>
      <div className="col-md-2 my-2 d-flex align-items-center">
        <img
          src="assets/img/639b830a4cbdd20fd5f3a9a9/csharp.svg"
          alt="C#"
          className="img-fluid"
        />
        <p className="font_14 mb-0">C#</p>
      </div>
    </div>
  </div>
</div>
</section>